<template>
    <div v-bind:class="{ 'high-contrast': settings.highContrast }" >
        <Spinner/>
        <modal-conflict-sync />
        <activity-container/>
        <b-container fluid class="p-0">
            <b-row class="no-gutters">
                <b-col lg="3" class="d-none d-lg-block" v-if="!$route.meta.hideSideNavigation">
                    <slot name="navigation"></slot>
                </b-col>
                <b-col cols="12" :lg="($route.meta.hideSideNavigation) ? '12' : '9'">
                    <AppHeader v-on:settings-change="onSettingsChange"/>
                    <slot></slot>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import AppHeader from './AppHeader.vue'
    import Spinner from './Spinner.vue'
    import ModalConflictSync from "./ModalConflictSync";
    import ActivityContainer from "./ActivityContainer"
    import {Storage, Zoom} from '../Utils'

    export default {
        name: 'PageBase',
        components: {
            AppHeader,
            Spinner,
            ActivityContainer,
            ModalConflictSync
        },
        data() {
            return {
                settings: {
                    highContrast: false,
                    fontSize: 100
                },
            }
        },
        methods: {
            onSettingsChange(newSettings) {
                this.settings.highContrast = newSettings.highContrast
            },
        },
        mounted() {
            const user = Storage.getUser()
            this.settings = { ...user }
            Zoom.setAppZoom(this.settings.fontSize)
        }
    }
</script>
